<template>
    <p>
        O pagamento desta parcela será realizado por débito em conta na sua conta do Nubank.
        <a
            href="https://nuapp.nubank.com.br/bnVhcHA6Ly9sZW5kaW5nL2hvbWU="
            target="_blank"
            rel="noopener"
            @click="handleClick"
        ><strong>Acesse o aplicativo do Nubank e garanta saldo suficiente em conta.</strong></a>
    </p>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { IPromessa } from '@/models/IPromessa';
import { acertoClickAcessarAplicativo } from '@/modules/events/acerto';

export default defineComponent({
  name: 'CompMsgDebitoEmConta',
  props: {
    proposta: { type: Object as PropType<IPromessa>, required: true },
  },
  setup(props) {
    const handleClick = () => {
      acertoClickAcessarAplicativo(props.proposta);
    };

    return {
      handleClick,
    };
  },
});
</script>

<style scoped>
a {
    color: inherit;
    text-decoration: underline;
}

a:hover {
    text-decoration: none;
}
</style>
